export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_3edf78d5-acfb-4184-b88f-4f9258375ea0/artifacts/cpumjibz_Tarini%20Astro%20Vastu.jpeg";

export const IMG = {
  heroMandala:
    "https://static.prod-images.emergentagent.com/jobs/3edf78d5-acfb-4184-b88f-4f9258375ea0/images/236725536900da65bc479b3e7c273d7adced7e4a24b249765af5413b58a9ace2.png",
  consultantProfile:
    "https://customer-assets.emergentagent.com/job_vastu-guidance-hub/artifacts/3gex8cen_Divya%20Agarwal%20Image%203.jpeg",
  vastuCompass:
    "https://static.prod-images.emergentagent.com/jobs/3edf78d5-acfb-4184-b88f-4f9258375ea0/images/fcf6db8948e8c1178280135d92c2108e9ca35b4fc705bf6aacb8f0a806adcdd8.png",
  mumbaiSkyline:
    "https://static.prod-images.emergentagent.com/jobs/3edf78d5-acfb-4184-b88f-4f9258375ea0/images/ca9b47cff322b87cd20d641f8e0927870a1ed0ef10324923b4351ece127f1f7c.png",
  brassDiya:
    "https://images.unsplash.com/photo-1775427528127-a66ce3bb2bcb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxicmFzcyUyMGRpeWElMjBkYXJrfGVufDB8fHx8MTc3NzYzMTcyMnww&ixlib=rb-4.1.0&q=85",
};
